const logoutDoorSVG = `
<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 4.5V1H1V22H14V18.5" stroke="white" stroke-linecap="round"/>
<path d="M5 11.5H21.5M21.5 11.5L16.5 6.5M21.5 11.5L16.5 16.5" stroke="white" stroke-linecap="round"/>
</svg>
`

export default logoutDoorSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/logoutDoorSVG.js